export default {
    data() {
        return {
            loading: false,
            loaded: false,
        };
    },

    methods: {
        startLoading(payload) {
            this.loading = true;
            if (payload) {
                return Promise.resolve(payload);
            } else {
                return Promise.resolve(true);
            }
        },
        stopLoading() {
            this.loading = false;
            this.loaded = true;
            return Promise.resolve(true);
        },
    },
};



// WEBPACK FOOTER //
// ./shared/mixins/loading.js